/**
 * @author vishwadeep.kapoor
 * @description Data Handlers for {GET,POST, DELETE, PUT} Methods implemented here
 */

import * as services from './index';
import endPoints from '../endPoints';
import * as utils from '../../devUtils/commonUtils';

const ERROR = {
  SERVICE_DEFAULT_ERR: 'Internal error (Service issue)',
  SERVICE_TECH_ERR: 'Please contact administrator',
  SUCCESS_RESPONSE_STATUS: 'SUCCESS',
};
/**
 * Data handler for GetData in services.js
 * @param {string} url
 * @returns JSON
 */

export const getHandler = (api, url, params, otherParams) => services.getData(api, url, params, otherParams).then(validateResponse).catch(handleError);

/**
 * Data handler for PostData in services.js
 * @param {string} url
 * @param {JSON} data
 * @returns JSON
 */
export const postHandler = (api, url, data, otherParams, isPlainJsData) => services.postData(api, url, data, otherParams, isPlainJsData).then(validateResponse).catch(handleError);

/**
 * Data handler for deleteData in services.js
 * @param {string} url
 * @param {string} identifier
 * @returns JSON
 */
export const deleteHandler = (api, url, identifier, otherParams) => services.deleteData(api, url, identifier, otherParams).then(validateResponse).catch(handleError);

/**
 * Data handler for putData in services.js
 * @param {string} url
 * @param {JSON} data
 * @returns JSON
 */
export const putHandler = (api, url, data, otherParams) => services.putData(api, url, data, otherParams).then(validateResponse).catch(handleError);

const handleError = (error) => {
  let errMsg = ERROR.SERVICE_DEFAULT_ERR;
  if (error instanceof Error) {
    if (error && error.request && error.request.status) {
      const errReq = error.request;
      errMsg = errReq.statusText;
      switch (errReq.status) {
        case 400:
        case 401:
        case 404:
        case 500:
        case 412:
        case 422:
        case 503:
        case 504:
          if (error && error.response && error.response.data && error.response.data.message) {
            errMsg = `${error.response.data.message}`;
          } else {
            errMsg = ERROR.SERVICE_DEFAULT_ERR;
          }
          logErrorToService(`www.zaggle.in:: Error response with - ${errReq.status}`, error.response, errReq.status);
          break;
        default:
          if (error && error.response && error.response.data && error.response.data.Error) {
            errMsg = `${ERROR.SERVICE_DEFAULT_ERR}:${error.response.data.Error.ErrorDescription}`;
          } else {
            errMsg = ERROR.SERVICE_TECH_ERR;
          }
          logErrorToService('www.zaggle.in:: Unknown Status Code', error.response);
          break;
      }
    } else {
      logErrorToService('www.zaggle.in:: Error status without Error Instance', error);
    }
  } else {
    logErrorToService('www.zaggle.in:: Error status without message from API reach', error);
  }
  console.log('defaultError................');
  return Promise.reject(errMsg);
};

const validateResponse = (response) => {
  if (response && response.data && response.status === 200) {
    const isV3API = response.request && response.request.responseURL && response.request.responseURL.includes('/v3/');
    if (isV3API) {
      return { ...response.data, status: true };
    }
    return response.data;
  }
  return handleError();
};

export const logErrorToService = (error, info, statusCode) => {
  if (Object.keys(utils.getWindowInstance()).length && !utils.isLocalhostInstance()) {
    const api = services.createAxiosInstance();
    const data = {
      error: error.toString(),
      data: { info, isBrowser: true },
      url: window.location.href,
    };
    try {
      services.postData(api, statusCode === 401 ? endPoints.POST_AUTH_LOGGER : endPoints.POST_ERROR_LOGGER,
        data, { isPlainJS: true })
        .then(validateResponse).catch(handleError);
    } catch (e) {
      // console.log('................', e);
    }
  }
};



// WEBPACK FOOTER //
// client/config/services/serviceHandler.js